import React from 'react';

interface LoadingProps {}

const Loading: React.FC<LoadingProps> = () => {
    return (
        <div className="flex h-[500px] w-full items-center justify-center">
            <p className="text-xl font-semibold text-gray-600">Loading...</p>
        </div>
    );
};

export default Loading;